import {Component, OnInit} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';
import {KeywordsService} from "../../providers/keywords-service";

/*
 Generated class for the KeywordsEdit page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'page-keywords-edit',
  templateUrl: 'keywords-edit.html'
})
export class KeywordsEditPage implements OnInit {

  keyword = {
    posiz: null,
    key: '',
    tag: '',
    color: 'FF0000',
    caseSensitive: false,
    mobilePush: false,
    enabled: true
  };

  colorList = [
    ['Nero', '000000'],
    ['Grigio', '808080'],
    ['Argento', 'C0C0C0'],
    ['Bianco', 'FFFFFF'],
    ['Granata', '800000'],
    ['Rosso', 'FF0000'],
    ['Verde oliva', '808000'],
    ['Giallo', 'FFFF00'],
    ['Verde', '008000'],
    ['Lime', '00FF00'],
    ['Teal', '008080'],
    ['Acqua', '00FFFF'],
    ['Blu scuro', '000080'],
    ['Blu', '0000FF'],
    ['Porpora', '800080'],
    ['Fucsia', 'FF00FF']
  ];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl: ViewController,
              private keywordsService: KeywordsService) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad KeywordsAddPage');
  }

  dismiss(data) {
    this.viewCtrl.dismiss(data);
  }

  ngOnInit() {
    this.keywordsService.getKeywords().subscribe(
      (data) => {
        this.keyword = data[+this.navParams.get('id')];
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/keywords-edit/keywords-edit.ts